import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: EASE
  }} className={className} data-id="element-325" data-mp="ydox8aejeujo">
      {children}
    </motion.div>;
}